import { createFeatureSelector } from '@ngrx/store';
import { DigiAIXCoreAppState } from './app-state';

export const selectDigitaixState = createFeatureSelector<DigiAIXCoreAppState['dx']>('dx');
